import { observable, action, computed, autorun } from 'mobx'
import { setter }                                from 'mobx-decorators'
import moment                                    from 'moment'
import _                                         from 'lodash'
import xhr                                       from 'helpers/XHR'
import getError                                  from 'helpers/ErrorParser'
import uiStore                                   from 'stores/UiStore'

export default class CallNote {
  parentCall = null
  id = null
  @observable body = ''
  @observable noteText = ''
  @observable createdAt = null
  @setter @observable isEditing = false
  @setter @observable isSaving = false
  @setter @observable isDeleting = false
  @setter @observable isNew = false
  @setter @observable isError = false

  constructor(json, parentCall) {
    this.initAutoruns()
    this.update(json)
    this.parentCall = parentCall
  }

  @computed get isOldest() {
    return _.last(this.parentCall.orderedNotes).id === this.id
  }

  @computed get isComposing() {
    return this.isNew || this.isEditing
  }

  @computed get canSave() {
    return this.noteText
  }

  @action initAutoruns = () => {
    this.autoErrorNotifier()
  }

  @action autoErrorNotifier = () => {
    this.autoErrorDisposer = autorun('Watch errors', () => {
      if (this.isError && !this.isError.hideNotification) {
        uiStore.addNotification({
          title:   this.isError.title,
          message: this.isError.message,
          type:    this.isError.type || 'error'
        })
      }
    })
  }

  @action onEditClick = () => {
    this.setIsEditing(true)
    this.noteText = this.body
  }

  @action onCancelClick = () => {
    this.setIsEditing(false)
    this.isNew && this.parentCall.callNotes.delete(this.id)
  }

  @action onChangeText = ({ target: { value } }) => {
    this.noteText = value
  }

  @action saveNote = async() => {
    try {
      this.setIsSaving(true)
      const { data } = await xhr.post(
        `/commo/call_log/${this.parentCall.id}/notes`,
        {
          body: this.noteText
        }
      )

      this.saveNoteOk(data)
    } catch (err) {
      this.setIsError(getError(err))
    } finally {
      this.setIsSaving(false)
    }
  }

  @action saveNoteOk = (data) => {
    this.setIsNew(false)
    this.parentCall.callNotes.delete(this.id)
    this.update(data.notes.pop())
    this.parentCall.callNotes.set(this.id, this)
  }

  @action updateNote = async() => {
    try {
      this.setIsSaving(true)
      const { data } = await xhr.put(
        `/commo/call_log/${this.parentCall.id}/notes/${this.id}`,
        {
          body: this.noteText
        }
      )

      this.updateNoteOk(data)
    } catch (err) {
      this.setIsError(getError(err))
    } finally {
      this.setIsSaving(false)
    }
  }

  @action updateNoteOk = () => {
    this.setIsEditing(false)
    this.body = this.noteText
  }

  @action deleteNote = async() => {
    try {
      this.setIsDeleting(true)
      await xhr.delete(
        `/commo/call_log/${this.parentCall.id}/notes/${this.id}`
      )

      this.deleteNoteOk()
    } catch (err) {
      this.setIsError(getError(err))
    } finally {
      this.setIsDeleting(false)
    }
  }

  @action deleteNoteOk = () => {
    this.parentCall.callNotes.delete(this.id)
  }

  @action update = ({ id, body, created_at, isNew }) => {
    this.id = id
    this.body = body
    this.createdAt = isNew ? moment().format() : created_at
    isNew && this.setIsNew(true)
  }
}
